import React, { Fragment } from 'react'
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { classNames } from '../../../../utils/className'

export default function OutputStructureV1_1({ sections }) {
  return (
    <div className="text-gray-500 text-sm whitespace-pre-line">
      {sections &&
        sections.map((section, sectionIndex) => {
          return (
            <div key={`section-${sectionIndex}`} className={'border-b border-gray-100 mb-8'}>
              {section.type === 'text' && (
                <div className={'pb-8'}>
                  {section.title && section.title !== '/' && section.title !== 'N/A' && (
                    <h3 className={'text-lg font-semibold text-indigo-600 pb-8'}>{section?.title}</h3>
                  )}

                  {section.data.value !== '' && (
                    <div className={'text-gray-700 text-sm leading-6'}>{section.data.value}</div>
                  )}
                  {section.data.value === '' && (
                    <div className={'text-gray-700 text-sm leading-6'}>
                      Processing result in in the wrong format. Please restart analysis or contact with our support.
                    </div>
                  )}
                </div>
              )}
              {section.type === 'list' && (
                <div>
                  {section.title && section.title !== '/' && section.title !== 'N/A' && (
                    <h3 className={'text-lg font-semibold text-indigo-600 pb-8'}>{section?.title}</h3>
                  )}
                  {Array.isArray(section.data) &&
                    section.data.map((listItem, itemIndex) => (
                      <div key={`section-${sectionIndex}-list-item-${itemIndex}`} className={'pb-4 mb-4'}>
                        {listItem.title && listItem.title !== '/' && listItem.title !== 'N/A' && (
                          <div className={'text-gray-700 text-xs font-semibold pb-4'}>{listItem.title}</div>
                        )}
                        <div className={'text-gray-700 text-sm leading-6'}>{listItem.value}</div>
                      </div>
                    ))}
                  {section.data['value'] && typeof section.data.value === 'string' && (
                    <div className={'text-gray-700 text-sm leading-6'}>{section.data.value}</div>
                  )}

                  {!Array.isArray(section.data) && !section.data['value'] && (
                    <div key={`section-${sectionIndex}-list-item-0`} className={'pb-4 mb-4'}>
                      Processing result in in the wrong format. Please restart analysis or contact with our support.
                    </div>
                  )}
                </div>
              )}

              {section.type === 'dynamic-table' && (
                <div>
                  {section.title && section.title !== '/' && section.title !== 'N/A' && (
                    <h3 className={'text-lg font-semibold text-indigo-600 pb-8'}>{section?.title}</h3>
                  )}
                  <div
                    className={classNames(
                      'grid gap-2',
                      section.data.headers.length === 1 && 'grid-cols-1',
                      section.data.headers.length === 2 && 'grid-cols-2',
                      section.data.headers.length === 3 && 'grid-cols-3',
                      section.data.headers.length === 4 && 'grid-cols-4',
                      section.data.headers.length === 5 && 'grid-cols-5',
                      section.data.headers.length === 6 && 'grid-cols-6',
                    )}
                  >
                    {section.data.headers.map((header, headerIndex) => (
                      <div
                        key={`section-${sectionIndex}-col-header-${headerIndex}`}
                        className={'p-2 mb-2 bg-gray-50 rounded-md hover:bg-indigo-50'}
                      >
                        <div className={'text-gray-700 font-semibold text-sm leading-6'}>{header.name || header}</div>
                      </div>
                    ))}
                  </div>

                  {section.data.rows.map((row, rowIndex) => (
                    <div
                      key={`section-${sectionIndex}-row-${rowIndex}`}
                      className={classNames(
                        'grid gap-x-2 border-b border-gray-100 hover:bg-gray-50 rounded-md',
                        section.data.headers.length === 1 && 'grid-cols-1',
                        section.data.headers.length === 2 && 'grid-cols-2',
                        section.data.headers.length === 3 && 'grid-cols-3',
                        section.data.headers.length === 4 && 'grid-cols-4',
                        section.data.headers.length === 5 && 'grid-cols-5',
                        section.data.headers.length === 6 && 'grid-cols-6',
                      )}
                    >
                      {row.map((cell, cellIndex) => (
                        <div key={`section-${sectionIndex}-row-${rowIndex}-cell-${cellIndex}`} className={'p-2 mb-2'}>
                          {cell.value}
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              )}

              {section.type === 'table' && (
                <div>
                  {section.title && section.title !== '/' && section.title !== 'N/A' && (
                    <h3 className={'text-lg font-semibold text-indigo-600 pb-8'}>{section?.title}</h3>
                  )}

                  <div
                    className={classNames(
                      'grid gap-2',
                      section.data.headers.length === 1 && 'grid-cols-1',
                      section.data.headers.length === 2 && 'grid-cols-2',
                      section.data.headers.length === 3 && 'grid-cols-3',
                      section.data.headers.length === 4 && 'grid-cols-4',
                      section.data.headers.length === 5 && 'grid-cols-5',
                      section.data.headers.length === 6 && 'grid-cols-6',
                    )}
                  >
                    {section.data.headers.map((header, headerIndex) => (
                      <div
                        key={`section-${sectionIndex}-col-header-${headerIndex}`}
                        className={'p-2 mb-2 bg-gray-50 rounded-md hover:bg-indigo-50'}
                      >
                        <div className={'text-gray-700 font-semibold text-sm leading-6'}>{header.name || header}</div>
                      </div>
                    ))}
                  </div>
                  {section.data.rows.map((row, rowIndex) => (
                    <div
                      key={`section-${sectionIndex}-row-${rowIndex}`}
                      className={classNames(
                        'grid gap-x-2 border-b border-gray-100 hover:bg-gray-50 rounded-md',
                        section.data.headers.length === 1 && 'grid-cols-1',
                        section.data.headers.length === 2 && 'grid-cols-2',
                        section.data.headers.length === 3 && 'grid-cols-3',
                        section.data.headers.length === 4 && 'grid-cols-4',
                        section.data.headers.length === 5 && 'grid-cols-5',
                        section.data.headers.length === 6 && 'grid-cols-6',
                      )}
                    >
                      {row.map((cell, cellIndex) => (
                        <div key={`section-${sectionIndex}-row-${rowIndex}-cell-${cellIndex}`} className={'p-2 mb-2'}>
                          {cell.type !== 'boolean' && cell.value}
                          {cell.type === 'boolean' && (
                            <>
                              {typeof cell.value === 'boolean' && (
                                <>
                                  {cell.value && (
                                    <div className={'flex flex-row items-center'}>
                                      <div
                                        className={
                                          'w-6 h-6 bg-green-600 rounded-md flex items-center justify-center mr-2'
                                        }
                                      >
                                        <CheckIcon className={'w-4 h-4 text-white'} />
                                      </div>
                                      True
                                    </div>
                                  )}
                                  {!cell.value && (
                                    <div className={'flex flex-row items-center'}>
                                      <div
                                        className={
                                          'w-6 h-6 bg-red-600 rounded-md flex items-center justify-center mr-2'
                                        }
                                      >
                                        <XMarkIcon className={'w-4 h-4 text-white'} />
                                      </div>
                                      False
                                    </div>
                                  )}
                                </>
                              )}

                              {typeof cell.value !== 'boolean' && (
                                <>
                                  {parseInt(cell.value) === 1 && (
                                    <div className={'flex flex-row items-center'}>
                                      <div
                                        className={
                                          'w-6 h-6 bg-green-600 rounded-md flex items-center justify-center mr-2'
                                        }
                                      >
                                        <CheckIcon className={'w-4 h-4 text-white'} />
                                      </div>
                                      True
                                    </div>
                                  )}
                                  {parseInt(cell.value) === 0 && (
                                    <div className={'flex flex-row items-center'}>
                                      <div
                                        className={
                                          'w-6 h-6 bg-red-600 rounded-md flex items-center justify-center mr-2'
                                        }
                                      >
                                        <XMarkIcon className={'w-4 h-4 text-white'} />
                                      </div>
                                      False
                                    </div>
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )
        })}
    </div>
  )
}
